import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCustomRoleIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0.646182 13.5859C2.29032 11.41 4.88013 10 7.79773 10C10.7153 10 13.3051 11.41 14.9493 13.5859C14.9567 13.5958 14.9642 13.6056 14.9717 13.6155C15.113 13.8025 15.2646 14.0029 15.3729 14.1963C15.504 14.4304 15.6012 14.7012 15.5952 15.0305C15.5904 15.2952 15.5101 15.543 15.4128 15.7387C15.3154 15.9343 15.166 16.1477 14.9577 16.3112C14.6799 16.5291 14.3775 16.6063 14.1089 16.6385C13.8732 16.6668 13.5938 16.6667 13.313 16.6667C13.3003 16.6667 13.2877 16.6667 13.275 16.6667H2.32042C2.30777 16.6667 2.29511 16.6667 2.28245 16.6667C2.00162 16.6667 1.7223 16.6668 1.4866 16.6385C1.21794 16.6063 0.915517 16.5291 0.637747 16.3112C0.42946 16.1477 0.280104 15.9343 0.182707 15.7387C0.0853107 15.543 0.00510649 15.2952 0.00026535 15.0305C-0.00575715 14.7012 0.0914165 14.4304 0.222529 14.1963C0.330851 14.0029 0.482429 13.8025 0.623794 13.6155C0.631288 13.6056 0.638753 13.5958 0.646182 13.5859Z",
		fill: "#9E77ED"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.2144 4.58333C3.2144 2.05203 5.26642 0 7.79773 0C10.329 0 12.3811 2.05203 12.3811 4.58333C12.3811 7.11464 10.329 9.16667 7.79773 9.16667C5.26642 9.16667 3.2144 7.11464 3.2144 4.58333Z",
		fill: "#9E77ED"
	})]
});
export default SvgCustomRoleIcon;
